import React, { useEffect, useRef, useState } from "react";
import { TextField, Box, Typography } from "@mui/material";
var google;

export default function AddressAutocomplete({
  onAddressSelect,
  error,
  defaultValue = "",
}) {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    if (
      typeof google !== "undefined" &&
      google.maps?.places &&
      inputRef.current
    ) {
      try {
        const autocomplete = new google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["address"],
            componentRestrictions: { country: "it" },
            fields: ["address_components", "formatted_address", "geometry"],
          }
        );

        inputRef.current.addEventListener("keydown", (e) => {
          if (e.key === "Enter") e.preventDefault();
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (!place.geometry) return;

          // You must implement this utility or reuse the one you already have
          const components = extractAddressComponents(place);

          setInputValue(components.full_address);
          onAddressSelect(components);
        });
      } catch (err) {
        console.error("Google Maps Autocomplete init error:", err);
      }
    }
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);

    // fallback manuale
    onAddressSelect({
      full_address: val,
      street: val,
    });
  };

  return (
    <Box>
      <Typography variant="body2" fontWeight={600} mb={1}>
        Indirizzo di residenza completo *
      </Typography>

      <TextField
        fullWidth
        inputRef={inputRef}
        value={inputValue}
        onChange={handleChange}
        placeholder="Es. Via Roma 1, Milano"
        autoComplete="off"
        error={Boolean(error)}
        helperText={error || ""}
      />
    </Box>
  );
}

// You must import or define this function:
function extractAddressComponents(place) {
  // Your existing logic here
  return {
    full_address: place.formatted_address,
    street: place.formatted_address,
  };
}
